import { createAsyncThunk } from "@reduxjs/toolkit";
import { type Summary } from "../../../domain/entities/summary";
import { type SummaryDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const getSummary = createAsyncThunk<
  Summary,
  { supervisorId: string; businessDate: string },
  { dispatch: SummaryDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_SUMMARY, async ({ supervisorId, businessDate }, { extra }) => {
  return await extra.summaryRepo.getSummary(supervisorId, businessDate);
});
